export var BLOCK_NAME = 'Button-link-old';
export var BUTTON_OVERLAY_TIMEOUT = 150;
export var BUTTON_VARIANTS = {
    accent: 'accent',
    interface: 'interface',
    main: 'main',
    neutral: 'neutral',
    positive: 'positive',
    negative: 'negative',
    remove: 'remove',
    link: 'link',
    'link-without-underline': 'link-without-underline',
    onlyIcon: 'only-icon',
    onlyIconInline: 'only-icon-inline',
    'footer-link': 'only-icon',
};
